import PropTypes from "prop-types";

import CloseIcon from "@mui/icons-material/Close";
import ThumbDownAltOutlinedIcon from "@mui/icons-material/ThumbDownAltOutlined";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import mixedSentimentIcon from "../../../assets/icons/mixedSentiment.png";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";

const DEFAULT_AGE_GROUPS = ["25-34", "35-44", "45-55", "56-64"];

function formatAgeRangeLabel(label) {
    if (!label) return "Unknown";
    if (/year|old|\+/.test(label.toLowerCase())) return label;
    return `${label} years`;
}

function ViewMoreModal({ isOpen, onClose, title, expandedResponses }) {
    const responseGroups = expandedResponses || {};
    const responseAgeGroups = Object.keys(responseGroups);
    const ageGroups = responseAgeGroups.length ? responseAgeGroups : DEFAULT_AGE_GROUPS;

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            fullWidth
            maxWidth="xl"
            PaperProps={{ className: "tta-dialog-paper" }}
        >
            <DialogTitle className="tta-dialog-title">
                {title}
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    className="tta-dialog-close color-blue"
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent className="tta-dialog-content">
                <div className="tta-modal-grid">
                    {ageGroups.map((key) => {
                        const responses = responseGroups[key] || [];
                        return (
                            <div key={key}>
                                <strong>{formatAgeRangeLabel(key)}</strong>
                                {responses.length > 0 ? (
                                    responses.map((item, index) => (
                                        <p key={item.responseId || `${key}-${index}`}>
                                            {item.sentiment === "Exclusively Positive" ? (
                                                <ThumbUpAltOutlinedIcon className="tta-verbatim-icon positive" />
                                            ) : item.sentiment === "Exclusively Negative" ? (
                                                <ThumbDownAltOutlinedIcon className="tta-verbatim-icon negative" />
                                            ) : (
                                                <img
                                                    src={mixedSentimentIcon}
                                                    className="tta-verbatim-icon mixed"
                                                    alt="Both positive and negative"
                                                />
                                            )}
                                            {`"${item.response}"`}
                                        </p>
                                    ))
                                ) : (
                                    <p className="color-disabled">No responses available</p>
                                )}
                            </div>
                        );
                    })}
                </div>
            </DialogContent>
        </Dialog>
    );
}

ViewMoreModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    title: PropTypes.string,
    expandedResponses: PropTypes.object,
};

export default ViewMoreModal;
